import { withInstall } from '@jdesign-vue/utils'

import Flex from './src/flex.vue'

export const JdFlex = withInstall(Flex)
export default JdFlex

export * from './src/flex'
export * from './src/constants'
export * from './src/use-flex'
